@if (response$ | async; as response) {
  <ng-container>
    <nexweb-tso-form
      [response]="response"
      [labels]="labels"
      [dateTimeFormat]="dateTimeFormat"
      (formValuesChanged)="formValuesChanged($event)"
      (formValidationChanged)="formValidationChanged($event)"></nexweb-tso-form>
  </ng-container>
}
